
// APENAS para os livros/capítulos:
const R2_URL = "https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/biblioteca-online-htmls";

/**
 * Busca o conteúdo de um livro do R2 de forma segura.
 * @param bookPath O caminho do arquivo (ex: "id.html")
 * @returns O conteúdo em texto do arquivo
 */
export const getBookContent = async (bookPath: string): Promise<string> => {
    // Garanta que não há barras duplas na montagem da URL
    const cleanPath = bookPath.startsWith('/') ? bookPath.slice(1) : bookPath;
    const url = `${R2_URL}/${cleanPath}`;

    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Erro ao buscar livro: ${response.status} ${response.statusText}`);
    }

    return response.text();
};
